// for components that just needs styling
import * as React from 'react'
import classnames from 'classnames'

const createSimpleComponent = ({ displayName, className: cl, Component = 'div' }) => {
  class SimpleComponent extends React.PureComponent {
    render() {
      const { className, Component: PComponent, children, ...rest } = this.props
      return (
        <PComponent className={classnames(cl, className)} {...rest}>
          {children}
        </PComponent>
      )
    }
  }

  SimpleComponent.defaultProps = {
    className: null,
    Component,
    children: null,
  }

  SimpleComponent.displayName = displayName

  return SimpleComponent
}

export default createSimpleComponent
